module.exports = "<div class=\"onesite-base productGroup-panel\" wow-hide-scroll wow-scrollbar wow-hide-on-scroll=\"hideScroll-wrapper\">\r\n    <div class=\"productGroup-container productGroup-container--is-fixed\" ng-if=\"!isGroupLoading()\">\r\n        <span class=\"productGroup-productGroupName\">{{productGroupName()}}</span>\r\n        <span class=\"productGroup-productCount\" ng-if=\"!isCountLoading()\">({{productsCount()}})</span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"isCountLoading()\"></wow-loading-spinner>\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/productgroups/productgroup-template.html
 ** module id = 974
 ** module chunks = 1
 **/